import { ICategoryMenu } from "../../../model/respone/category/ICategoryMenu"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eCategoryMenuActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ICategoryMenu[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | ICategoryMenu,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as ICategoryMenu,
    SAVE_SUCCESS: {} as ICategoryMenu,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


}
export const eCategoryMenuActionTypeIds = generateActionTypeIds(eCategoryMenuActionTypeDefine, "CATEGORY_MENU")

export type ICategoryMenuActions = IGenericActionType<typeof eCategoryMenuActionTypeDefine, "CATEGORY_MENU">


